/* eslint-disable @typescript-eslint/explicit-module-boundary-types */

import { getAppInstance } from "../appContext";
import { nextStep } from "../components/StepPopper";
import { EDITOR_VIEW_NAME, PROJECT_COORDINATES } from "../core/constants";
import { getAppVersion } from "../core/version";
import { getViewData, setComponentData, setViewData } from "../core/views";
import { showSuccess } from "../features/successsteps";
import { setBackendStatus } from "./backend";
import { getUsedLineSeparator } from "./evaluate";
import { getCodeAtLine, getEditorLineNumberFromError, getLineIndexInCode } from "./loccount";

export const getInstanceFromWindow = () => {
  const instanceId = getAppInstance();
  return window.skApps[instanceId];
}

export const initGlobalsOnWindow = (instanceId) => {  
  if (window.skApps === undefined) {
    window.skApps = [];
  }
  window.skApps[instanceId] = {};
  window.skApps[instanceId].getUserCodeLength = getUserCodeLength;
  window.skApps[instanceId].checkIfUserCodeContains = checkIfUserCodeContains;
  window.skApps[instanceId].checkIfCodeLineContains = checkIfCodeLineContains;
  window.skApps[instanceId].showPointerCoordinates = showPointerCoordinates;
  window.skApps[instanceId].showMessage = showMessage;
  window.skApps[instanceId].showFinish = showFinish;
  window.skApps[instanceId].showError = showError;
  window.skApps[instanceId].sendBackendState = sendBackendState;
  window.skApps[instanceId].sendSessionStatus = sendSessionStatus;
  window.skVersion = skVersion;
  window.showFinish = showFinishGlobal;
  window.getUserCodeLength = getUserCodeLengthGlobal;
  window.checkIfUserCodeContains = checkIfUserCodeContainsGlobal;
  window.checkIfCodeLineContains = checkIfCodeLineContainsGlobal;
  window.showPointerCoordinates = showPointerCoordinatesGlobal;
  window.showMessage = showMessageGlobal;
  
  window.showError = showError;
  window.sendBackendState = sendBackendState;
  window.sendSessionStatus = sendSessionStatus;
}

const showFinishGlobal = (data) => {
  console.log('showFinishGlobal', data);
  getInstanceFromWindow().showFinish(data);
}

const getUserCodeLengthGlobal = () => {
  return getInstanceFromWindow().getUserCodeLength();
}

const checkIfUserCodeContainsGlobal = (key, lineFrom, lineTo) => {
  return getInstanceFromWindow().checkIfUserCodeContains(key, lineFrom, lineTo);
}

const checkIfCodeLineContainsGlobal = (keys) => {
  return getInstanceFromWindow().checkIfCodeLineContains(keys);
}

const showPointerCoordinatesGlobal = (x, y) => {
  getInstanceFromWindow().showPointerCoordinates(x, y);
}

const showMessageGlobal = (title, message) => {
  getInstanceFromWindow().showMessage(title, message);
}

export const getUserCodeLength = () => {
  const state = getViewData(EDITOR_VIEW_NAME)
  return state.data.editorCode.length;
}

export const checkIfUserCodeContains = (key, lineFrom, lineTo) => {
  if (lineFrom === undefined && lineTo === undefined) {
    const state = getViewData(EDITOR_VIEW_NAME)
    return state.data.editorCode !== undefined && state.data.editorCode.indexOf(key) > -1;
  }
  return false;
}

export const checkIfCodeLineContains = (keys) => {
  const state = getViewData(EDITOR_VIEW_NAME)
  const code = state.data.editorCode;
  const lineSep = getUsedLineSeparator(code);
  const lines = code.split(lineSep);
  let found = 0;
  let keysFound = false
  lines.forEach((line, index) => {
    found = 0;
    keys.forEach((key) => {
      if (line.indexOf(key) > -1) {
        found++;
      }
    })
    if (found === (keys.length)) {
      keysFound = true;
    }
  });
  return keysFound;
}

export function showPointerCoordinates(x, y) { // eslint-disable-line no-unused-vars
  const coords = {
    x : Math.floor(x),
    y : Math.floor(y)
  }
  setComponentData(PROJECT_COORDINATES, coords);
}

function showMessage(title, message) { // eslint-disable-line no-unused-vars
  //TODO showModal needed?
  //showModal(title, message);
}

export function requestFinish(data) {
  showFinish(data);  
}

function showFinish(data) {
  const state = getViewData(EDITOR_VIEW_NAME)
  if (state.project.steps !== undefined && state.project.steps.length > 0) {
    nextStep(data);
  } else {
    showSuccess();
  }
}

function showError(error) {
  const editorState = getViewData(EDITOR_VIEW_NAME);
  //console.log('showError', error);
  if (editorState.data.errors === undefined) {
    editorState.data = {
      ...editorState.data,
      errors : []
    }
  }

  if (error.filename === "about:srcdoc" || error.filename?.indexOf("robotLibrary.js") > -1) {
    const codeAtLine = getCodeAtLine(error.lineno, editorState.data.executionCode);
    const realErrorLine = getLineIndexInCode(codeAtLine, editorState.data.editorCode) + 1;
    
    const newErrors = [ ...editorState.data.errors ];
    newErrors.push(error);
    editorState.data = {
      ...editorState.data,
      errorLine : realErrorLine,
      errors : newErrors,      
      errorCounter: editorState.data.errorCounter === undefined ? 1 : editorState.data.errorCounter + 1
    };
    setViewData(EDITOR_VIEW_NAME, editorState);
  }
  if (error.filename === "sandkasten.js") {
    const realErrorLine = getEditorLineNumberFromError(editorState.data.executionCode, error.lineno, editorState.data.editorCode);

    
    const newErrors = [ ...editorState.data.errors ];
    newErrors.push(error);
    editorState.data = {
      ...editorState.data,
      errorLine : realErrorLine,
      errors : newErrors,      
      errorCounter: editorState.data.errorCounter === undefined ? 1 : editorState.data.errorCounter + 1
    };
    setViewData(EDITOR_VIEW_NAME, editorState);
  }

}

export const setAceEditor = (ace) => {
  const instanceId = getAppInstance();
  window.skApps[instanceId].aceEditor = ace;
}

export const skVersion = () => {
  return getAppVersion();
}


function sendBackendState(state) {
  //console.log('sendBackendState', state);
  setBackendStatus(state);
}

function sendSessionStatus(text, status) {
  //console.log('sendSessionStatus', text, status);
}
